import React, { useEffect, useRef } from 'react';
import { mountRootParcel, Parcel } from 'single-spa';
import classnames from 'classnames';
import style from '../RenewNowModal/RenewNowModal.module.scss';
import { IAccess } from '../../context/AppSettings.context';
import { createPortal } from 'react-dom';

interface IProps {
  close: () => void;
  accesses?: IAccess[],
}

const ModalWithPaywall = ({close, accesses}: IProps) => {
  const containerRef = useRef(null);
  const parcelRef = useRef<Parcel>(null);
  useEffect(() => {
    if (containerRef.current) {
      // @ts-ignore
      // eslint-disable-next-line no-restricted-properties
      parcelRef.current = mountRootParcel(() => System.import('@ternala/ftn-paywall'), {
        domElement: containerRef.current,
        accesses: accesses || []
      });
    }

    return () => {
      // прибираємо при розмонтуванні React-компонента
      parcelRef.current?.unmount();
    };
  }, []);

  return (
    <>
    {createPortal(<div className={classnames(style.renew_popup, 'modal active')}>
      <div className={'modal__overlay'} onClick={close}>
        <div className={classnames('modal__form', style.modal__form)} onClick={e => e.stopPropagation()}
             style={{minWidth: '80vw'}}>
          <div className="modal__close" onClick={close}>
            <svg>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M.86 18.906zm-.574-.573a.977.977 0 101.381 1.381L19.714 1.667a.977.977 0 10-1.381-1.38L.286 18.332z"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M19.714 18.333L1.667.286a.977.977 0 00-1.38 1.381l18.046 18.047a.973.973 0 001.233.122.977.977 0 00.148-1.503z"/>
            </svg>
          </div>
          <div className="modal__form__text">
            <div ref={containerRef}/>
          </div>
        </div>
      </div>
    </div>, document.body)}
    </>
  );
};

export default ModalWithPaywall;
